/**
 * StubPage — MVP 미구현 탭 자리표시
 */
import React from 'react';
import styled from 'styled-components';

const StubPage = ({ title }) => (
  <Wrap>
    <Big>{title}</Big>
  </Wrap>
);

export default StubPage;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
`;

const Big = styled.p`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`;
